{
  "GENERAL": {
    "CLOSE": "Bezárás",
    "SHOWING_RESULTS": "{firstIndex}-{lastIndex} / {totalCount} elem",
    "PHONE_INPUT": {
      "PLACEHOLDER": "Keresés",
      "EMPTY_STATE": "Nincs találat"
    }
  },
  "TAG_INPUT": {
    "MIN_TAGS_REQUIRED": "Legalább {count} szükséges"
  }
}
